export class ProviderChange {
  change: string;
  catalogObject: CustomProvider;
}
export class CustomProvider {
  deployOnParent: boolean;
  id: string;
  name: string;
  type: string;
  parentId: string;
  isInProduction: boolean;
  content: ProviderContent;
}
export class ProviderContent {
  displayName: string;
  description: boolean;
  class: any;
  virtualizationEnabled: boolean;
  replicationEnabled: boolean;
  environments: Array<any>;
}
